import { createContext } from 'react'

import type { SearchProps } from './search'

export type SearchAddonContext = Partial<SearchProps>

export const SearchAddonContext = createContext<SearchAddonContext>({})
